export const buildDashboardSnapshot = ({todos = []}) => {
    const recentTodos = [...todos]
        .sort(
            (a, b) =>
                new Date(b.createdAt) -
                new Date(a.createdAt)
        )
        .slice(0, 50);
    const total = recentTodos.length;

    const done = recentTodos.filter(
        (t) => t.status === "Done"
    ).length;

    const planned = recentTodos.filter(
        (t) => t.status === "Planned"
    ).length;

    const cancelled = recentTodos.filter(
        (t) => t.status === "Cancelled"
    ).length;

    const productivityScore = total
        ? Math.round((done / total) * 100)
        : 0;

    // =========================
    // OBJECTIVES
    // =========================

    const objectiveMap = {};

    recentTodos.forEach((t) => {
        const key = t.objective || "Unknown";
        objectiveMap[key] = (objectiveMap[key] || 0) + 1;
    });

    // =========================
    // SIGNAL SCORES
    // =========================

    const focusObjectives =
        (objectiveMap.Build || 0) +
        (objectiveMap.Focus || 0) +
        (objectiveMap.Learning || 0);

    const focusScore = Math.min(
        100,
        Math.round((focusObjectives / Math.max(total, 1)) * 100)
    );

    const consistencyScore = Math.min(
        100,
        Math.round((done / Math.max(done + cancelled, 1)) * 100)
    );

    const disciplineScore = Math.min(
        100,
        Math.round((done / Math.max(total, 1)) * 100)
    );

    // =========================
    // ROACH SCORE
    // =========================

    // const avgRoachScore =
    //     recentRoaches.length
    //         ? Number(
    //               (
    //                   recentRoaches.reduce(
    //                       (acc, curr) =>
    //                           acc + (curr.avgScore || 0),
    //                       0
    //                   ) / recentRoaches.length
    //               ).toFixed(1)
    //           )
    //         : 0;

    // const resilienceScore = Math.min(
    //     100,
    //     Math.round((avgRoachScore / 9) * 100)
    // );

    // const latestRoach = recentRoaches[0] || null;

    // =========================
    // FINAL SCORE
    // =========================

    const finalScore = Math.round(
        (
            productivityScore +
            focusScore +
            consistencyScore +
            disciplineScore 
            // + resilienceScore
        ) / 4
    );

    // =========================
    // ZONE
    // =========================

    let zone = "Recovery Zone";

    if (finalScore >= 80) zone = "Peak Zone";
    else if (finalScore >= 65) zone = "Momentum Zone";
    else if (finalScore >= 45) zone = "Builder Zone";

    // =========================
    // STREAK
    // =========================

    let currentStreak = 0;

    const streakTodos = [...recentTodos].sort(
        (a, b) =>
            new Date(b.createdAt) -
            new Date(a.createdAt)
    );

    for (const t of streakTodos) {
        if (t.status === "Done") currentStreak++;
        else break;
    }

    // =========================
    // TREND (7 days)
    // =========================

    const trend = Array(7).fill(0);

    recentTodos.forEach((t) => {
        const day = new Date(t.createdAt).getDay();
        const index = day === 0 ? 6 : day - 1;

        if (t.status === "Done") trend[index] += 15;
        if (t.status === "Planned") trend[index] += 6;
        if (t.status === "Cancelled") trend[index] -= 5;
    });

    const normalizedTrend = trend.map((v) =>
        v < 0 ? 0 : v > 100 ? 100 : v
    );

    // =========================
    // ENERGY
    // =========================

    const energy = Math.min(
        100,
        Math.round(disciplineScore)
    );

    // =========================
    // INSIGHTS
    // =========================

    const insights = [];

    if (focusScore >= 70)
        insights.push("Deep-work focus improving steadily.");

    if (consistencyScore >= 70)
        insights.push("Consistency pattern becoming stronger.");

    if (cancelled >= 5)
        insights.push("Distraction signals increased recently.");

    // if (resilienceScore >= 65)
    //     insights.push("Behavior resilience remains stable.");

    if (!insights.length)
        insights.push("Small daily wins will compound over time.");

    // =========================
    // RECOMMENDATION
    // =========================

    let recommendedAction =
        "Complete one focused task before opening social media.";

    if (focusScore < 40)
        recommendedAction =
            "Reduce multitasking and finish one important task fully.";

    else if (consistencyScore < 50)
        recommendedAction =
            "Focus on maintaining a daily completion streak.";

    // else if (resilienceScore < 45)
    //     recommendedAction =
    //         "Prioritize recovery and mental reset today.";

    // =========================
    // RETURN
    // =========================

    return {
        score: finalScore,
        zone,

        streak: {
            current: currentStreak,
        },

        stats: {
            total,
            done,
            planned,
            cancelled,
        },

        signals: {
            focus: focusScore,
            consistency: consistencyScore,
            discipline: disciplineScore,
            // resilience: resilienceScore,
            energy,
        },

        trend: normalizedTrend,

        // behavior: {
        //     roachScore: avgRoachScore,
        //     roachType: latestRoach?.type || "Unknown Survivor",
        // },

        objectives: {
            distribution: objectiveMap,
        },

        insights,

        recommendedAction,
    };
};